import Button from '@mui/material/Button';
import type { Dispatch, SetStateAction } from 'react';

type GridMapType = 'cadastral' | 'osm';

interface ShowHideButtonsForMapsProps {
  mapType: GridMapType;
  setMapType: Dispatch<SetStateAction<GridMapType>>;
  onBeforeChangeMapType?: () => void;
}

const ShowHideButtonsForMaps = ({ mapType, setMapType, onBeforeChangeMapType }: ShowHideButtonsForMapsProps) => {
  const handleChangeMapType = (nextMapType: GridMapType) => {
    onBeforeChangeMapType?.();
    setMapType(nextMapType);
  };

  return (
    <div className="grid-map-switcher">
      <Button
        type="button"
        className={`grid-map-switcher__button ${mapType === 'cadastral' ? 'grid-map-switcher__button--active' : ''}`}
        onClick={() => handleChangeMapType('cadastral')}
      >
        Cadastral
      </Button>
      <Button
        type="button"
        className={`grid-map-switcher__button ${mapType === 'osm' ? 'grid-map-switcher__button--active' : ''}`}
        onClick={() => handleChangeMapType('osm')}
      >
        Landscape
      </Button>
    </div>
  );
};

export default ShowHideButtonsForMaps;
